import { Box, Typography } from "@mui/material";

interface Props {
  label: string;
  value: number | string; 
  icon: React.ReactNode;
  color: string;
  bg: string;
}

const StatCard = ({ label, value, icon, color, bg }: Props) => {
  return (
    <Box
      sx={{
        flex: "1 1 220px",
        borderRadius: "16px",
        p: 2,
        background: bg,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        transition: "all 0.25s ease",
        border: "1px solid #eef2f7",
            boxShadow: "0 6px 18px rgba(0,0,0,0.06)",

        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
        },
      }}
    >
      {/* LEFT */}
      <Box>
        <Typography
          sx={{
            fontSize: "13px",
            color: "#64748b",
            mb: 0.5,
            fontWeight: "bold"
          }}
        >
          {label}
        </Typography>

        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 700,
            color: "#0f172a",
          }}
        >
          {value}
        </Typography>
      </Box>

      {/* RIGHT ICON */}
      <Box
        sx={{
          width: 42,
          height: 42,
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "white",
          color: color,
          boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
        }}
      >
        {icon}
      </Box>
    </Box>
  );
};

export default StatCard;